import { useState } from "react";
import { Radio, X, AlertTriangle } from "lucide-react";
import { useHive } from "@/context/HiveContext";

// Compact fleet-status bar: shows OCTON HIVE link state and the latest critical
// cross-ship alert. Dismissible per alert.
export function HiveBanner() {
  const { online, latest } = useHive();
  const [dismissed, setDismissed] = useState(null);
  const showAlert = latest && latest.hive_id && dismissed !== latest.hive_id;
  const p = latest?.payload || {};
  const label = p.title || p.message || p.name || p.kind || latest?.type;

  return (
    <div className="flex items-center gap-3 px-4 py-2 border-b border-[#1E222A] bg-[#0A0C10]"
         data-testid="hive-banner">
      <span className="flex items-center gap-1.5 shrink-0" data-testid="hive-status-pill">
        <Radio className={`w-3.5 h-3.5 ${online ? "text-acid" : "text-[#5A6072]"}`} />
        <span className="mono-label" style={{ color: online ? "#CCFF00" : "#5A6072" }}>
          {online ? "OCTON HIVE LINKED" : "HIVE OFFLINE"}
        </span>
      </span>
      {showAlert ? (
        <div className="flex items-center gap-2 min-w-0 flex-1" data-testid="hive-alert-row">
          <AlertTriangle className="w-3.5 h-3.5 text-pulseError shrink-0" />
          <span className="text-xs text-white/85 truncate">
            <span className="text-pulseError font-semibold">{latest.ship_from || "Fleet"}</span>
            {" · "}{label}
          </span>
          <button onClick={() => setDismissed(latest.hive_id)} data-testid="hive-alert-dismiss"
                  className="ml-auto text-[#5A6072] hover:text-white transition-colors shrink-0">
            <X className="w-3.5 h-3.5" />
          </button>
        </div>
      ) : (
        <span className="mono-label text-[#5A6072] truncate">octon fleet nervous system</span>
      )}
    </div>
  );
}
